module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av65-2bc67a477a8d33b7f0b7eb6e340521b2.jpg";